export default "__VITE_ASSET__8f23c108__"